import { FaTwitter, FaInstagram, FaGithub, FaLinkedinIn } from "react-icons/fa"
export const socialLinks = [
  {
    name: "Github",
    href: "https://github.com/nsharma1396",
    icon: FaGithub,
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/in/nsharma1396",
    icon: FaLinkedinIn,
  },
  {
    name: "Twitter",
    href: "https://twitter.com/nsharma1396",
    icon: FaTwitter,
  },
  {
    name: "Instagram",
    href: "https://instagram.com/nsharma1396",
    icon: FaInstagram,
  },
]
